import React, { useState } from "react";
import "./TweetReviewer.css";

const TweetReviewer = ({ tweet, onAction }) => {
  const [copyFeedback, setCopyFeedback] = useState("");

  const formatDate = (dateStr) => {
    try {
      return new Date(dateStr.replace(/·/g, "")).toLocaleDateString("es-ES", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return dateStr;
    }
  };

  const openLink = () => {
    if (tweet.link) {
      window.open(tweet.link, "_blank");
    }
  };

  const copyUsername = async () => {
    try {
      await navigator.clipboard.writeText(tweet.user);
      setCopyFeedback("¡Copiado!");
      setTimeout(() => setCopyFeedback(""), 2000);
    } catch (err) {
      // Fallback para navegadores que no soporten clipboard API
      const textArea = document.createElement("textarea");
      textArea.value = tweet.user;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      setCopyFeedback("¡Copiado!");
      setTimeout(() => setCopyFeedback(""), 2000);
    }
  };

  return (
    <div className="tweet-reviewer">
      <div className="tweet-card">
        <div className="tweet-header">
          <span
            className="tweet-user"
            onClick={copyUsername}
            title="Hacer clic para copiar al portapapeles"
          >
            {tweet.user}
            {copyFeedback && (
              <span className="copy-feedback">{copyFeedback}</span>
            )}
          </span>
          <span className="tweet-date">{formatDate(tweet.date)}</span>
        </div>

        <div className="tweet-content">
          <p>{tweet.content}</p>
        </div>

        <div className="tweet-actions">
          <button
            className="link-button"
            onClick={openLink}
            disabled={!tweet.link}
          >
            Ver Tweet Original
          </button>
        </div>
      </div>

      <div className="action-buttons">
        <button
          className="action-button contacted-button"
          onClick={() => onAction("contacted")}
        >
          Contactado
        </button>
        <button
          className="action-button delete-button"
          onClick={() => onAction("deleted")}
        >
          Borrar
        </button>
      </div>
    </div>
  );
};

export default TweetReviewer;
